import * as yup from 'yup'

import questionnaireResponsesSchema from './questionnaireResponsesSchema'

const timeUseFormSchema = (t) =>
	yup.tuple([yup.object(), questionnaireResponsesSchema(t), yup.object()])

export default timeUseFormSchema
